<!-- 设备列表页面 -->
<template>
  <div class="vcnDeviceList vcnDevicelist_warpd">
    <!--主页面 -->
    <div class="flex-row"
         style="height: 100%">
      <!-- 左侧树 -->
      <div class="section-mian_left">
        <el-scrollbar class="scroll-bar-view">
          <el-tree :data="frame"
                   :props="treeProps"
                   class="shebeiDiv"
                   @node-click="currentChange"
                   :expand-on-click-node="true"
                   :default-expand-all="false"
                   :default-expanded-keys="['1']"
                   :highlight-current="true"
                   node-key="thirdDeviceId"
                   ref="vuetree"></el-tree>
        </el-scrollbar>
      </div>
      <!-- 右侧表单 -->
      <div class="section-mian_right">
        <!-- 主机设备列表 -->
        <div class="nvr-table">
          <!-- 头部按钮 -->
          <div class="section-mian__toolbar flex-row">
            <el-button type="primary"
                       class="iss-operation-button"
                       icon="iconfont icon-iconfontfanhui"
                       @click="retBtn">返回</el-button>
            <el-button type="primary"
                       class="iss-operation-button"
                       icon="el-icon-plus"
                       v-auth="'/deviceaccess/index:addDevice'"
                       @click="add">新增</el-button>
            <el-button type="primary"
                       class="iss-operation-button"
                       icon="el-icon-delete"
                       v-auth="'/deviceaccess/index:deleteDevice'"
                       @click="delDev">批量删除</el-button>
          </div>
          <!-- 表格部分 -->
          <div class="section-main_table">
            <ioc-table ref="devTab"
                       :data="deviceData"
                       :option="deviceOption"
                       :page="devicePage"
                       @row-save="handleCreate"
                       @row-update="handleUpdate"
                       @search-change="handleSearchChange"
                       @search-reset="resetForm"
                       @current-change="selectPage"
                       @selection-change="selectionChange"
                       @size-change="changeSize">
              <!-- 定制操作栏按钮 -->
              <template slot="menu"
                        slot-scope="scope">
                <el-tooltip class="item"
                            effect="dark"
                            content="修改"
                            placement="top"
                            popper-class="tooltip-draw">
                  <el-button type="text"
                             v-auth="'/deviceaccess/index:updateDevice'"
                             @click="update(scope.row)"
                             icon="iconfont icon-xiugai"></el-button>
                </el-tooltip>
                <el-tooltip class="item"
                            effect="dark"
                            content="详情"
                            placement="top"
                            popper-class="tooltip-draw">
                  <el-button type="text"
                             class="iconfont icon-Detail"
                             @click="showDetail(scope.row)"></el-button>
                </el-tooltip>

              </template>
              <!-- 新增/修改表单 自定义 -->
              <!-- <template slot="addFormSet">
                <div span="12">
                  <label for="">是否在室内</label>
                  <el-select v-model="devInAddData.isIndoor"
                             @change="selectChange">
                    <el-option v-for="item in isIndoorList"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </div>

                <div>
                  <label for="">经度:</label>
                  <el-input v-model="devInAddData.longitude"
                            placeholder="请输入经度"></el-input>
                </div>

                <div>
                  <label for="">纬度:</label>
                  <el-input v-model="devInAddData.latitude"
                            class="position-set"
                            placeholder="请输入纬度"></el-input>
                  <el-button type="text"
                             size="small"
                             class="iconfont icon-position map-choose"
                             @click="openMap"></el-button>
                </div>

                <div>
                  <label for="">所属楼栋:</label>
                  <el-input v-model="devInAddData.buildingName"
                            class="position-set"
                            placeholder="请选择所属楼栋"></el-input>
                  <el-button type="text"
                             size="small"
                             class="iconfont icon-position map-choose"
                             @click="openBuilding"></el-button>
                </div>
                <div>
                  <label for="">设备描述:</label>
                  <el-input v-model="devInAddData.buildingName"
                            type="textarea"
                            maxlength="120"
                            show-word-limit
                            class="position-set"
                            placeholder="请输入设备描述"></el-input>
                </div>
              </template> -->
            </ioc-table>
          </div>
        </div>
      </div>
    </div>
    <!-- add+update设备数据弹框  -->
    <el-dialog :title="dialogTitle"
               :close-on-click-modal="false"
               v-dialogDrag
               :visible.sync="editDevDialog"
               width="66%"
               :center="true"
               show-close
               destroy-on-close>
      <edit-dev ref="editDev"></edit-dev>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   :loading="diaLoading"
                   @click="editDlgPre">{{diaLoading?"保存中...":"保 存"}}</el-button>
        <el-button @click="editDlgCan">{{diaLoading?"保存中...":"取 消"}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../../api/index";
import { Dic, Dates } from "$utils";
import utils from '@src/common/utils'
import i18n from "@src/common/lib/i18n";
import { tableOption } from '../../config/electricTable'
import { partOption } from '../../config/partTable'
import sha256 from 'js-sha256'
import editDev from './electricFireDia'
export default {
  components: { editDev },
  data () {
    return {
      isIndoorList: [{
        label: "是",
        value: "1"
      }, {
        label: "否",
        value: "0"
      }],
      devInAddData: {
        isIndoor: '',
        latitude: '',
        abscissa: '',
        buildingName: ''


      },
      activeName: 'first',
      tipData: "",
      diaLoading: false,
      // 单个删除设备的数据
      delDevSin: {},
      delConfirm: false,
      // 设备详情数据
      devDtail: {
        deviceHost: "",
        thirdDeviceId: "",
        parentCode: "",
        type: "",
        netType: "",
        enableVoice: "",
        deviceCreateTime: "",
        deviceSubType: "",
        isExDomain: "",
        deviceName: "",
        domainCode: "",
        cameraLocation: "",
        status: "",
        isSupportIntelligent: "",
        nvrCode: "",
        buildingName: ''
      },
      dialogTitle: '',
      // 详情弹框
      dialogVisible: false,
      // 存储列表数据获取方式：1、通过左侧树；2、通过搜索条件；删除时用同样的方式刷新列表数据
      getDevListType: "",
      // 选中设备ID集合
      selDev: [],
      // 查询字段
      queryForm: {
        deviceName: '',
        thirdDeviceId: '',
      },
      editDevDialog: false,
      cameraQueryForm: {
        parentDeviceId: "",
        mac: "",
        deviceName: ""
      },
      // 系统id
      systemId: 200000012,
      platID: "",
      factoryId: "",
      systemName: "",
      deviceType: "",
      // 树的props
      treeProps: {
        label: "thirdDeviceName",
        children: "subDeviceList",
      },
      // 设备树的数据
      frame: [],
      // 树的节点值
      treeKey: "-1",
      // 设备ID
      deviceId: "",
      // 分页属性设置
      devicePage: {
        currentPage: 2,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },

      deviceData: [

      ],
      cameraData: [

      ],
      deviceOption: tableOption(this),
      level: "",
      cameraCount: {
        deviceAllCount: null,
        deviceOnlineCount: null,
        deviceOfflineCount: null,
      },
      statusOptions: [
        {
          label: '在线',
          value: '1'
        },
        {
          label: '离线',
          value: '0'
        }
      ],
      areaName: '',
      description: '',
      areaCode: '',
      formShow: false,
      statusFormShow: false,

    };
  },
  created () {
  },
  mounted () {
    this.getAccessDeviceInfoTree();
    // 请求设备列表
    this.queryDev();
  },
  methods: {
    // handleStatusChange(value){
    //   switch(value){
    //     case 
    //   }
    // },
    // 打开楼栋选择
    openBuilding () {
      if (this.devInData.fileCode) {
        this.rootDefaultDrawing = false;
      } else {
        this.rootDefaultDrawing = true;
      }
      this.imgUrl = this.getImgPath(this.devInData.fileCode);
      this.showBuilding = true;
      this.queryBuildingTree();
      this.$nextTick(() => {
        this.clickPoints();
        this.getCanvasWH();
        // 打点回显
        let wb = this.cW / this.devInData.width;
        let hb = this.cH / this.devInData.height;
        setTimeout(() => {

          let ctx = this.initCanvas();

          let img = this.$refs.camImg
          ctx.drawImage(img, Math.round(this.devInData.abscissa * wb - 10), Math.round(this.devInData.ordinate * hb - 10), 20, 20);
        }, 2000)
        let _this = this;
        window.onresize = function () {
          _this.watchScreen();
        };
      });

    },
    queryBuildingTree () {
      this.$fetch(api.queryBuildingTree).then(res => {
        const result = this.menusDataPro(res.returnObj);
        this.treeData = Object.freeze(result);
        this.expandedKeys = this.expandedKeys.length ? this.expandedKeys : [this.treeData[0].id];
        // this.$refs.tree.setCheckedKeys([this.devInData.buildingCode] || []);
      })
    },
    //递归树结构
    menusDataPro (data) {
      const self = this
      const result = []
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {}
          entity.id = item.buildingCode
          entity.name = item.buildingName
          entity.parentCode = item.parentCode
          entity.type = item.type
          entity.fileCode = item.fileCode
          entity.desc = item.desc
          entity.isLeaf = !item.hasLeaf || !item.subBuildingList
          if (item.subBuildingList) {
            entity.children = self.menusDataPro(item.subBuildingList)
          }
          result.push(entity)
        })
        return result
      }
    },
    // 新增/编辑保存
    editDlgPre () {
      let data = {};
      data = this.$refs.editDev.devInData;
      this.$refs.editDev.validateForm().then(valid => {
        if (valid) {
          let url = ""
          let params = {}
          if (this.dialogTitle == '新增设备') {
            // params.parentDeviceId = "200000012";
            // params.parentDeviceIds = "200000012"
            url = api.electricFire.addElectricalFireDevice
            params = {
              buildingCode: data.buildingCode,//所属楼栋
              abscissa: data.abscissa,
              ordinate: data.ordinate,
              height: data.height,
              width: data.width,
              latitude: data.latitude,
              longitude: data.longitude,
              isIndoor: data.isIndoor,
              deviceHost: data.deviceHost,                // 设备IP
              devicePort: data.devicePort,
              //status: data.status,//设备状态
              systemId: 200000012,
              parentDeviceId: 200000012, // 传固定值
              parentDeviceIds: "200000012",
              slaveId: 1,                                 // 从机地址
              thirdDeviceId: data.thirdDeviceId,//设备第三方id
              thirdDeviceName: data.thirdDeviceName,//设备名称
              thirdDeviceDesc: data.thirdDeviceDesc,//设备描述
              deviceExtendInfoMap: {
                zAlarmTime: data.zAlarmTime,
                zBattery: data.zBattery,
                zBusinessName: data.zBusinessName,
                zDeviceType: data.zDeviceType,
                zFmeter: data.zFmeter,
                zGVersion: data.zGVersion,
                zGrade: data.zGrade,
                zHeartTime: data.zHeartTime,
                zIDinteger: data.zIDinteger,
                zJmeter: data.zJmeter,
                zLinkNum: data.zLinkNum,
                zLinkTime: data.zLinkTime,
                zRange: data.zRange,
                zSVersion: data.zSVersion,
                zSetHeartTime: data.zSetHeartTime,
                zSetLinkNum: data.zSetLinkNum,
                zSetLinkTime: data.zSetLinkTime,
                zSetStress: data.zSetStress,
                zSetTime: data.zSetTime,
                zSmeter: data.zSmeter,
                zSnr: data.zSnr,
                zStates: data.zStates,
              }
            };
          } else {
            url = api.electricFire.updateElectricalFireDevice
            params = {
              buildingCode: data.buildingCode,//所属楼栋
              abscissa: data.abscissa,
              ordinate: data.ordinate,
              height: data.height,
              width: data.width,
              latitude: data.latitude,
              longitude: data.longitude,
              isIndoor: data.isIndoor,
              deviceHost: data.deviceHost,                // 设备IP
              devicePort: data.devicePort,
              slaveId: 1,
              deviceID: data.deviceID,
              thirdDeviceId: data.thirdDeviceId,//设备第三方id
              thirdDeviceName: data.thirdDeviceName,//设备名称
              thirdDeviceDesc: data.thirdDeviceDesc,//设备描述
              deviceExtendInfoMap: {
                zAlarmTime: data.zAlarmTime,
                zBattery: data.zBattery,
                zBusinessName: data.zBusinessName,
                zDeviceType: data.zDeviceType,
                zFmeter: data.zFmeter,
                zGVersion: data.zGVersion,
                zGrade: data.zGrade,
                zHeartTime: data.zHeartTime,
                zIDinteger: data.zIDinteger,
                zJmeter: data.zJmeter,
                zLinkNum: data.zLinkNum,
                zLinkTime: data.zLinkTime,
                zRange: data.zRange,
                zSVersion: data.zSVersion,
                zSetHeartTime: data.zSetHeartTime,
                zSetLinkNum: data.zSetLinkNum,
                zSetLinkTime: data.zSetLinkTime,
                zSetStress: data.zSetStress,
                zSetTime: data.zSetTime,
                zSmeter: data.zSmeter,
                zSnr: data.zSnr,
                zStates: data.zStates,
              }
            }
          }
          this.diaLoading = true
          this.$fetch(url, params).then(res => {
            setTimeout(() => {
              this.diaLoading = false
            }, 500)
            if (res.success) {
              this.$message.success(res.msgContent);
              this.editDevDialog = false;
              this.queryDev();
            } else {
              this.$message.error(res.msgContent);
              this.queryDev();
            }
          })
        } else {
          return false
        }
      })
    },
    // 编辑框取消按钮
    editDlgCan () {
      // this.$refs.editDev.devInData.resolutionWide = '';
      // this.$refs.editDev.devInData.resolutionHigh = '';
      this.editDevDialog = false;
    },
    handleClick (tab, event) {
      console.log(tab, event);
    },
    // 返回按钮
    retBtn () {
      this.$router.go(-1);
    },

    // 树的子节点点击事件
    currentChange (data, node) {
      this.$log.info("树的子节点点击", data);
      this.isTopTreeNode = data.areaCode !== '-1' ? false : true
      // let parentNode = this.$refs.vuetree.getNode(data.parentCode)
      this.areaCode = data.areaCode
      this.treeKey = data.deviceID;
      this.level = node.level;
      if (this.level) {
        this.deviceId = data.deviceID;
      }
      this.getDevList();
    },
    // 请求数据列表数据
    requestList () {
      const param = {
        deviceName: this.queryForm.deviceName,
        pageNum: this.devicePage.currentPage,
        pageSize: this.devicePage.pageSize,
        systemId: 200000012,
        thirdDeviceId: this.queryForm.thirdDeviceId,
      };
      this.$fetch(api.electricFire.queryElectricalFireDevice, param).then((res) => {
        if (res.success && res.returnObj.list) {
          this.deviceData = res.returnObj.list;
          this.devicePage.total = res.returnObj.total;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 根据查询条件查询列表
    queryDev () {
      this.devicePage.currentPage = 1;
      this.requestList();
      // if (this.devShow) {
      //   this.devicePage.currentPage = 1;
      //   this.getDevListType = 1;
      //   this.requestList();
      // } else {
      //   this.requestCameraList()
      // }
    },

    // 批量删除设备
    delDev () {
      if (this.selDev.length === 0) {
        this.$message.warning(this.$t("deviceAccess.message.deltips"));
        return;
      }
      this.delConfirm = true;
      this.$confirm(
        this.$t("deviceAccess.message.uninstall"),
        this.$t("deviceAccess.title.uninstall"),
        {
          confirmButtonText: this.$t("deviceAccess.button.confirm"),
          cancelButtonText: this.$t("deviceAccess.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.deleteSubDevice();
      });
    },
    // 确认删除
    deletePlatDevice (row) {
      this.devicePage.currentPage = 1;
      this.delConfirm = false;
      let params = { deviceIDList: this.selDev };
      // this.$fetch(api.electricFire.deleteElectricalFireDevice, params).then((res) => {
      //   if (res.success) {
      //       this.getDevList();
      //       this.$message.success(this.$t("deviceAccess.message.delsuccess"));
      //   } else {
      //     this.$message.error(res.msgContent);
      //   }
      //   this.$refs.devTab.selectClear();
      // });
    },
    // 确认删除
    deleteSubDevice (row) {
      this.devicePage.currentPage = 1;
      this.delConfirm = false;
      let params = { deviceIDList: this.selDev };
      this.$fetch(api.electricFire.deleteElectricalFireDevice, params).then((res) => {
        if (res.success) {
          this.requestList();
          this.$message.success(this.$t("deviceAccess.message.delsuccess"));
        } else {
          this.$message.error(res.msgContent);
        }
        this.$refs.partTab.selectClear();
      });
    },

    // 取消删除
    dlgNo () {
      this.delConfirm = false;
    },

    refresh (row) {
      const params = {
        deviceID: row.deviceID,
      };
      this.$fetch(api.device.queryPlatSystemDeviceDetail, params).then(
        (res) => {
          if (res.success) {
            row.status = res.returnObj.status;
            this.$message.success(res.msgContent);
          } else {
            this.$message.error(res.msgContent);
          }
        }
      );
    },

    //迭代四  新接口 查看详情
    showDetail (row) {
      if (row.isIndoor == "1") {
        this.$refs.devTab.option.column[10].viewDisplay = false;
        this.$refs.devTab.option.column[11].viewDisplay = false;
        this.$refs.devTab.option.column[9].viewDisplay = true;
        this.$refs.devTab.option.column[12].viewDisplay = true;
        this.$refs.devTab.option.column[13].viewDisplay = true;
        this.$refs.devTab.option.column[14].viewDisplay = true;
        this.$refs.devTab.option.column[15].viewDisplay = true;
      } else {
        this.$refs.devTab.option.column[10].viewDisplay = true;
        this.$refs.devTab.option.column[11].viewDisplay = true;
        this.$refs.devTab.option.column[9].viewDisplay = false;
        this.$refs.devTab.option.column[12].viewDisplay = false;
        this.$refs.devTab.option.column[13].viewDisplay = false;
        this.$refs.devTab.option.column[14].viewDisplay = false;
        this.$refs.devTab.option.column[15].viewDisplay = false;
        // console.log('================fewhhufiwuie00000', this.$refs.editDev)
      }
      this.$refs.devTab.rowView(row)
    },
    //查看部件列表
    seeCamera (row) {
      this.parentDeviceId = row.deviceID
      this.parentThirdDeviceId = row.thirdDeviceId
      this.factoryId = row.factoryId
      this.devShow = false
      this.requestCameraList()
    },
    seeStatus (row) {
      const params = {
        "pageNum": 1,
        "pageSize": 10,
        "thirdDeviceId": row.thirdDeviceId
      }
      this.$fetch(api.device.queryVideoStream, params).then((res) => {
        if (res.success) {
          this.videoStreamData = res.returnObj.list;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    backNvr () {
      this.devShow = true
      this.cameraQueryForm = {
        parentDeviceId: "",
        mac: "",
        deviceName: ""
      }
    },
    // 重置搜索
    resetForm () {

      this.devicePage.pageSize = utils.Cache.get('CURRENT_PAGESIZE') || 10;
      this.devicePage.pageNo = 1;
      this.queryForm = {
        deviceName: "",
        thirdDeviceId: "",
      };
      // 请求设备列表
      this.requestList();
      this.devicePage.currentPage = 1;
    },

    // 当选择项发生变化时会触发该事件
    selectionChange (selections) {
      let myAry = [];
      selections.map((item) => {
        myAry.push(item.deviceID);
      });
      this.selDev = myAry;
    },
    // 点击上一页下一页按钮
    selectPage (val) {
      this.devicePage.currentPage = val;
      this.requestList();
    },
    // 修改每页数据数量
    changeSize (val) {
      this.devicePage.currentPage = 1;
      this.devicePage.pageSize = val;
      this.requestList();
      // if (this.devShow) {
      //   this.devicePage.currentPage = 1;
      //   this.devicePage.pageSize = val;
      //   if (this.getDevListType == 1) {
      //     this.queryDev();
      //   } else if (this.getDevListType == 2) {
      //     this.getDevList();
      //   }
      // } else {
      //   this.cameraPage.currentPage = 1;
      //   this.cameraPage.pageSize = val;
      //   this.requestCameraList()
      // }
    },
    addClick (event) {
      event.stopPropagation()
    },
    editArea (node, data) {
      this.areaName = data.areaName
      this.areaCode = data.areaCode
      this.description = data.description
      this.formShow = true;
    },
    formClose () {
      this.formShow = false;
      this.areaName = ''
    },
    getAccessDeviceInfoTree () {
      const params = {
        systemId: this.systemId,
      };
      this.$fetch(api.device.queryPlatSystemDeviceTree, params).then((res) => {
        if (res.success) {
          this.frame = [res.returnObj];
          this.$nextTick(() => {
            this.$refs.vuetree.setCurrentKey("-1");
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    saveArea () {
      const params = {
        "areaCode": this.areaCode,
        "areaName": this.areaName,
        "description": this.description,
        "connectMode": "EDGE",
        "pushDomain": "push.sdnewtimes.com",
        "pullDomain": "play.sdnewtimes.com"
      }
      this.$fetch(api.device.updateArea, params).then(
        (res) => {
          if (res.success) {
            this.formShow = false
            this.getAccessDeviceInfoTree()
            this.$message.success('修改成功')
          } else {
            this.$message.error(res.msgContent);
          }
        }
      );
    },
    add () {
      //  this.$refs.devTab.rowAdd()
      //  this.$refs.devTab.rowAdd()
      this.editDevDialog = true

      this.addBtn = true,
        this.dialogTitle = "新增设备"
      this.$nextTick(() => {
        this.key += 1
      })
    },
    update (row) {
      this.rowInfo = { ...row }
      // this.editDevDialog = true
      this.editDevDialog = true
      this.dialogTitle = "修改设备"
      // data = this.$refs.editDev.devInData;
      this.$nextTick(() => {
        this.$refs.editDev.devInData = Object.assign(row, row.deviceExtendInfoMap);
        this.$refs.editDev.selectChange(row.isIndoor)
        // this.$refs.editDev.devInData.isIndoor = parseInt(row.isIndoor)
      })

    },
    // 新增主机
    handleCreate (addInfo, done) {
      this.$refs['devTab'].$refs['form'].validate((valid) => {
        if (!valid) {
          return false
        } else {
          let form = {
            parentDeviceId: "200000024",
            parentDeviceIds: "200000024",
            systemId: 200000024,
            factoryId: addInfo.factoryId,
            thirdDeviceName: addInfo.deviceName,
          }
          const params = Object.assign(addInfo, form)
          this.$fetch(api.device.addFireDevice, params).then((res) => {
            if (res && res.success) {
              this.requestList()
              this.$message.success('新增成功')
            } else {
              this.$message.error(res.msgContent)
            }
            done()
          })
        }
      })
    },
    handlePartCreate (addInfo, done) {
      this.$refs['partTab'].$refs['form'].validate((valid) => {
        if (!valid) {
          return false
        } else {
          let params = {
            abscissa: this.abscissa,                            // 横坐标
            buildingCode: this.buildingCode,             // 楼栋楼层编号
            deviceHost: this.deviceHost,                // 设备IP
            devicePort: 8085,                           // 设备端口
            height: this.height,                              // 高度
            ordinate: "429",                            // 纵坐标
            parentDeviceId: 200000012,                  // 传固定值
            parentDeviceIds: "200000012",               // 传固定值
            slaveId: 1,                                 // 从机地址
            systemId: 200000012,                        // 传固定值
            thirdDeviceDesc: this.thirdDeviceDesc,            // 描述
            thirdDeviceId: this.thirdDeviceId,             // 设备ID(即第三方设备id)
            thirdDeviceName: this.thirdDeviceName,            // 设备名称
            width: "1348",                              // 宽度
          }

          this.$fetch(api.device.addFireSubDevice, params).then((res) => {
            if (res && res.success) {
              this.requestCameraList()
              this.$message.success('新增成功')
            } else {
              this.$message.error(res.msgContent)
            }
            done()
          })
        }
      })
    },
    handlePartUpdate (updateInfo, done) {
      this.$refs['partTab'].$refs['form'].validate((valid) => {
        if (!valid) {
          return false
        } else {
          let form = {
            deviceID: this.rowInfo.deviceID,
            factoryId: this.factoryId,
            subDeviceMark: updateInfo.subDeviceMark,
            mac: updateInfo.mac,
            loop: updateInfo.loop,
            thirdDeviceName: updateInfo.deviceName,
            thirdDeviceDesc: updateInfo.thirdDeviceDesc,
            secondaryCode: updateInfo.secondaryCode,
            controlCode: updateInfo.controlCode
          }
          this.$fetch(api.device.updateFireSubDevice, form).then((res) => {
            if (res && res.success) {
              this.requestCameraList()
              this.$message.success('修改成功')
            } else {
              this.$message.error(res.msgContent)
            }
            done()
          })
        }
      })
    },
    // 修改主机
    handleUpdate (updateInfo, done) {
      this.$refs['devTab'].$refs['form'].validate((valid) => {

        if (!valid) {
          return false
        } else {
          let form = {
            controlMode: updateInfo.controlMode,
            codeType: updateInfo.codeType,
            deviceID: this.rowInfo.deviceID,
            factoryId: updateInfo.factoryId,
            deviceHost: updateInfo.deviceHost,
            mac: updateInfo.mac,
            typeMark: updateInfo.typeMark,
            thirdDeviceName: updateInfo.deviceName,
            thirdDeviceDesc: updateInfo.thirdDeviceDesc,
            deviceVersion: updateInfo.deviceVersion,
          }
          this.$fetch(api.device.updateFireDevice, form).then((res) => {
            if (res && res.success) {
              this.requestList()
              this.$message.success('修改成功')
            } else {
              this.$message.error(res.msgContent)
            }
            done()
          })
        }
      })
    },
    queryFactoryList () {
      this.$fetch(api.device.queryFireDeviceFactoryList).then((res) => {
        if (res.success) {
          this.deviceOption.column[2].dicData = res.returnObj.map(item => {
            return {
              label: item.factoryName,
              value: Number(item.factoryId),
            }
          })
        }
      });
    },
    // 批量导入按钮
    batchImport (file) {
      if (
        file.name.substring(
          file.name.lastIndexOf(".") + 1,
          file.name.length
        ) !== "xlsx" &&
        file.name.substring(
          file.name.lastIndexOf(".") + 1,
          file.name.length
        ) !== "xls"
      ) {
        this.$message({
          message: "文件格式不正确",
          type: "warning",
        });
      } else {
        let formData = new FormData();
        formData.append("file", file.raw);
        // 调用导入接口
        this.$fetch(api.device.importFireDevice, formData).then((response) => {
          if (response.success) {
            this.$message({
              message: "导入文件成功",
              type: "success",
            });
            this.requestList();
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
            });
          }
          this.$refs.upload.clearFiles();
        });
      }
    },
    exportData () {
      const params = {
        "systemId": 200000024,                          // 固定值
        "mac": this.queryForm.mac,                     // 系统地址
        "deviceName": this.queryForm.deviceName,        // 设备名称
        "thirdDeviceId": this.queryForm.thirdDeviceId,   // 唯一标识号
        "deviceMarkList": ["27", "28", "29"]               // 固定值
      }
      this.$fetchDownLoad(api.device.exportFireDevice, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        if (response.data || response.success) {
          const content = response.data;
          const blob = new Blob([content], {
            type: "application/vnd.ms-excel",
          });
          //  console.log('date',window.DATE)
          const fileName =
            "消防主机列表" +
            Dates.format(Date.now(), "yyyyMMddHHmmssms") +
            ".xlsx";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else {
          this.$message.error("导出请求失败，请稍后重试");
        }
      });
    },
    handleSearchChange (param) {
      if (param.thirdDeviceName) {
        param.deviceName = param.thirdDeviceName
      }
      this.queryForm = param
      this.devicePage.currentPage = 1
      this.requestList();
      // if (this.devShow) {
      //   this.queryForm = param
      //   this.devicePage.currentPage = 1
      //   this.requestList()
      // } else {
      //   this.cameraQueryForm.deviceName = param.thirdDeviceName
      //   this.cameraQueryForm.mac = param.mac
      //   this.cameraPage.currentPage = 1
      //   this.requestCameraList()
      // }
    },
    setPassword (row) {
      this.dialogVisible = true
      this.deviceId = row.deviceID
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            deviceId: this.deviceId,
            oldUnlockPassword: sha256(this.ruleForm.oldUnlockPassword),
            newUnlockPassword: sha256(this.ruleForm.newUnlockPassword),
            confirmUnlockPassword: sha256(this.ruleForm.confirmUnlockPassword),
          }
          this.$fetch(api.device.updateDeviceUnlockPassword, params).then((res) => {
            if (res.success) {
              this.$message.success('修改成功')
              this.$refs[formName].resetFields();
              this.dialogVisible = false
            } else {
              this.$message.error(res.msgContent)
            }
          });
        } else {
          return false;
        }
      });
    },
    reset (formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false
    }
  }
};
</script>
<style lang="scss" scoped>
.vcnDeviceList {
  .position-set {
    position: relative;
  }
  .map-choose {
    position: absolute;
    right: -5px;
    top: 0px;
  }
  #map-container {
    height: 450px;
  }
  width: 100%;
  height: 100%;
  .section-main__warp {
    margin: 0 !important;
  }
  .upload-demo {
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.position-set {
  position: relative;
}
.map-choose {
  position: absolute;
  right: -5px;
  top: 0px;
}
#map-container {
  height: 450px;
}
.vcnDevicelist_warpd {
  .el-table__fixed-right-patch {
    display: none;
  }
  .devDtaildata {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .nvr-table {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .tree-content {
    width: fit-content;
    min-width: 100%;
    .el-tree-node__label {
      display: inline-block;
      max-width: 80%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .el-tree-node__content {
      height: 40px;
      line-height: 40px;
      &:hover {
        background: rgb(45, 73, 118);
      }
      .custom-tree-node {
        width: 100%;
        height: 40px;
        line-height: 40px;
        display: flex;
        .tree-label {
          width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .area-operator {
          display: inline-block;
          margin-left: 10px;
        }
      }
      &:before {
        margin-top: -26px !important;
      }
    }
  }
  .scroll-bar-view {
    // @include set_theme_color(background-color, top-menu-bg-color);
    height: calc(100% - 0px);
    .el-scrollbar__wrap {
      // height: calc(100% - 100px);
      .el-scrollbar__view {
        display: inline-block;
        min-width: 100%;
      }
    }
  }
}
.el-select {
  width: 100%;
}
</style>
